import { LimitRequestConditionPrecedentType } from "../../../../graphql/generated.ts";
import { toHumanReadable } from "../../../../utils/string.ts";

export const typeOptions = Object.values(
  LimitRequestConditionPrecedentType
).map((value) => {
  return { value, label: toHumanReadable(value) };
});
